
import React from "react";
import { UseFormRegister, FieldErrors } from "react-hook-form";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { CourseFormData } from "../types";

interface PricingFieldsProps {
  register: UseFormRegister<CourseFormData>;
  errors: FieldErrors<CourseFormData>;
}

export function PricingFields({ register, errors }: PricingFieldsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div className="space-y-2">
        <Label htmlFor="price">Price</Label>
        <Input
          id="price"
          type="number"
          step="0.01"
          {...register("price", { 
            required: "Price is required",
            min: { value: 0, message: "Price must be positive" }
          })}
        />
        {errors.price && <p className="text-sm text-red-500">{errors.price.message}</p>}
      </div>

      <div className="space-y-2">
        <Label htmlFor="original_price">Original Price</Label>
        <Input
          id="original_price"
          type="number"
          step="0.01"
          {...register("original_price", { 
            required: "Original price is required",
            min: { value: 0, message: "Original price must be positive" }
          })}
        />
        {errors.original_price && <p className="text-sm text-red-500">{errors.original_price.message}</p>}
      </div>

      <div className="space-y-2">
        <Label htmlFor="state_fee">State Fee (Optional)</Label>
        <Input
          id="state_fee"
          type="number"
          step="0.01"
          {...register("state_fee", { 
            min: { value: 0, message: "State fee must be positive" }
          })}
        />
        {errors.state_fee && <p className="text-sm text-red-500">{errors.state_fee.message}</p>}
      </div>
    </div>
  );
}
